<template>
  <el-container>
    <el-main style="padding: 0; margin-top: 5px;">
      <el-container direction="vertical" style="overflow-x: hidden">
        <el-row>
          <el-col :span="24">
            <div class="list">
              <HeaderBar :title="barTitle"></HeaderBar>
              <div class="list-card">
                <el-table
                  :data="lists"
                  :row-style="rowStyle"
                  :cell-style="cellStyle"
                  :show-header="false"
                  max-height="320px"
                  @row-click="handleRowClickEvent"
                >
                  <el-table-column prop="title" width="" show-overflow-tooltip align="left">
                  </el-table-column>
                  <el-table-column prop="companyName" width="160" show-overflow-tooltip align="center">
                  </el-table-column>
                  <el-table-column prop="createDate" width="120" align="right">
                  </el-table-column>
                </el-table>
                <el-divider v-if="totalElements > 10"></el-divider>
                <el-pagination
                  :background="true"
                  layout="prev, pager, next"
                  :total="totalElements"
                  :current-page="pageNo"
                  @current-change="handleSizeChangeEvent"
                  hide-on-single-page
                >
                </el-pagination>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-container>
    </el-main>
  </el-container>
</template>

<script>
import * as dayjs from 'dayjs';
import HeaderBar from '@/components/HeaderBar.vue';
import { prefixedUrlAsset } from '@/utils/constants';

export default {
  name: 'MemberIntro',
  components: { HeaderBar },
  data() {
    return {
      pageNo: 0,
      pageSize: 10,
      totalElements: 0,
      barTitle: '会员简介',
      lists: [],
    };
  },
  created() {
    this.startRequestListApi();
  },
  methods: {
    cellStyle() {
      return 'padding: 0px; font-size:14px; height: 32px; border: none; cursor: pointer;';
    },
    rowStyle() {
      return 'white-space: nowrap;';
    },
    handleSizeChangeEvent(pageNo) {
      this.pageNo = pageNo - 1;
      this.startRequestListApi();
    },
    handleRowClickEvent(row) {
      this.$router.push({ path: `/detail/${row.newsId || row.id}` });
    },
    startRequestListApi() {
      this.axios
        .get(`${prefixedUrlAsset}/api/pub/member/info/list`, {
          params: { pageNo: this.pageNo, pageSize: this.pageSize, catalogId: '1' },
        })
        .then((response) => {
          if (response.data.code === 0) {
            const data = response.data.data;
            this.pageNo = data.number + 1;
            this.totalElements = data.totalElements;
            this.lists = data.content.map((item) => ({
              id: item.id,
              newsId: item.newsId,
              title: item.title,
              companyName: item.companyName || '',
              createDate: dayjs(item.createDate).format('YYYY-MM-DD'),
            }));
          }
        });
    },
  },
};
</script>

<style lang="scss">
.list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: white;
  padding: 10px 10px 0px 10px;
  margin-bottom: 20px;
  .list-card {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 10px 10px 10px 10px;
    width: 100%;
    background-color: white;
    border-left: 1px solid #DCDCDC;
    border-right: 1px solid #DCDCDC;
    border-bottom: 1px solid #DCDCDC;
    box-sizing: border-box;
    border-radius: 0 0 15px 15px;
  }
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #026D31;
  color: #FFF;
}
</style>